import { z } from 'zod';

/**
 * Validation for the broadcast notification composer.
 * Enforces non-empty title/body, a sane body length, and that a destination is
 * chosen — either a city (full-state targeting is disabled for security) or a
 * test phone number, which overrides audience/city.
 */
export const broadcastSchema = z
  .object({
    appType: z.string().min(1, 'Select an App Type (ApnaYatri or JustZapIt)'),
    title: z.string().trim().min(1, 'Title is required'),
    body: z
      .string()
      .trim()
      .min(1, 'Message body is required')
      .max(160, 'Message body must be 160 characters or fewer'),
    city: z.string().optional(),
    testPhoneNumber: z.string().optional(),
  })
  .refine((d) => !!d.testPhoneNumber?.trim() || !!d.city?.trim(), {
    message: 'Select a city, or set a test phone number. Full-state targeting is disabled for security.',
    path: ['city'],
  });

export type BroadcastForm = z.infer<typeof broadcastSchema>;
